import  gql  from 'graphql-tag'

export const VERIFY_TOKEN = gql`mutation verifyToken($input: VerifyInput!){
    verifyToken(input: $input){
        payload
    }
}`;